module.exports = "/_next/static/pages/test-guidelines/26350d3ad743b741d95bb6320e2186a5.png";